"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asPhone = void 0;
var _isDefined = require("../misc-checks/isDefined");
var domesticMatch = /^(\d{3})(\d{3})(\d{4})$/;
var foreignMatch = /^(\d{3})(\d{4,12})$/;
var asPhone = exports.asPhone = function asPhone(phoneNumber) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    countryCode = _ref.countryCode,
    _ref$isForeign = _ref.isForeign,
    isForeign = _ref$isForeign === void 0 ? false : _ref$isForeign,
    _ref$outputPattern = _ref.outputPattern,
    outputPattern = _ref$outputPattern === void 0 ? "(###) ###-####" : _ref$outputPattern,
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? " " : _ref$separator;
  var returnStr = phoneNumber;
  // If incoming phone number begins with +1;
  if (/^\+1/.test(phoneNumber)) {
    // Set country code to 1;
    countryCode = "1";
    // Mark non-foreign;
    isForeign = false;
    // Trim the +1 from the number;
    returnStr = phoneNumber.substring(2);
  }
  // Define country code string;
  var countryCodeStr = (0, _isDefined.isDefined)(countryCode) ? "+" + countryCode + separator : "";
  // Clean all non-digit characters from phoneNumber string;
  var cleanedPhoneNumber = (returnStr + "").replace(/\D/g, "");
  // Define match from regular expression;
  var match = cleanedPhoneNumber.match(isForeign ? foreignMatch : domesticMatch);
  // If match exists and matches output pattern, return formatted string;
  if (match && !isForeign && outputPattern === "(###) ###-####") {
    returnStr = countryCodeStr + "(" + match[1] + ")" + separator + match[2] + "-" + match[3];
  } else if (match && !isForeign && outputPattern === "###-###-####") {
    returnStr = countryCodeStr + match[1] + "-" + match[2] + "-" + match[3];
  } else if (match && !isForeign && outputPattern === "###.###.####") {
    returnStr = countryCodeStr + match[1] + "." + match[2] + "." + match[3];
  } else if (match && isForeign && outputPattern === "(###) ####") {
    returnStr = countryCodeStr + "(" + match[1] + ")" + separator + match[2];
  } else if (match && isForeign && outputPattern === "###-####") {
    returnStr = countryCodeStr + match[1] + "-" + match[2];
  } else if (match && isForeign && outputPattern === "###.####") {
    returnStr = countryCodeStr + match[1] + "." + match[2];
  }
  // Return the string;
  return returnStr;
};